var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "message", staticClass: "ui error message" }, [
    _c("i", { staticClass: "close icon", on: { click: _vm.close } }),
    _vm._v(" "),
    _vm.error.header
      ? _c("div", { staticClass: "header" }, [
          _vm._v("\n        " + _vm._s(_vm.error.header) + "\n    ")
        ])
      : _vm._e(),
    _vm._v(" "),
    !Array.isArray(_vm.error.message)
      ? _c("p", [_vm._v(_vm._s(_vm.error.message))])
      : _vm._e(),
    _vm._v(" "),
    Array.isArray(_vm.error.message)
      ? _c(
          "ul",
          _vm._l(_vm.error.message, function(msg) {
            return _c("li", [_vm._v(_vm._s(msg))])
          })
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3de5e1b1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3de5e1b1","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/admin/errorDisplay.vue
// module id = 526
// module chunks = 0